import axios from 'axios';
import authHeader from './auth-header';
import Jsona from "jsona";

const API_URL = process.env.VUE_APP_API_BASE_URL;
const dataFormatter = new Jsona();

export default {
    async getServices(params) {
        const response = await axios.get(API_URL + "/services", { headers: authHeader(), params: params });
        return { data: dataFormatter.deserialize(response.data), meta: response.data.meta?.page };
    },

    async addService(service) {
        service.type = "services"
        const newJson = dataFormatter.serialize({ stuff: service })
        const response = await axios.post(API_URL + "/services", newJson, { headers: authHeader() });
        return dataFormatter.deserialize(response.data);
    },

    async deleteService(serviceId) {
        await axios.delete(API_URL + "/services/" + serviceId, { headers: authHeader() });
    },

    async getService(serviceId) {
        const response = await axios.get(API_URL + "/services/" + serviceId, { headers: authHeader() });
        return dataFormatter.deserialize(response.data);
    },

    async editService(service) {
        service.type = "services"
        const newJson = dataFormatter.serialize({ stuff: service })
        const response = await axios.patch(API_URL + "/services/" + service.id, newJson, { headers: authHeader() });
        return dataFormatter.deserialize(response.data);
    },
}




